import { Check, Copy } from "lucide-react";
import { useState } from "react";
import s from "./developers.module.css";

export function CodeBlock({ code, label }: { code: string; label?: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <div className={s.codeWrap}>
      {label ? <div className={s.codeLabel}>{label}</div> : null}
      <pre className={s.code}>
        <code>{code}</code>
        <button
          type="button"
          className={s.copy}
          aria-label="Copy"
          onClick={() => {
            void navigator.clipboard.writeText(code).then(() => {
              setCopied(true);
              setTimeout(() => setCopied(false), 1200);
            });
          }}
        >
          {copied ? <Check size={12} /> : <Copy size={12} />}
        </button>
      </pre>
    </div>
  );
}
